const _excluded = ["children"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { FlightsResultsProviders } from '@edreamsodigeo/frontend-flights-results';
import PrimeResultsProvider from './PrimeResultsProvider';
const FlightResultsProvider = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(PrimeResultsProvider, null, /*#__PURE__*/React.createElement(FlightsResultsProviders, rest, children));
};
FlightResultsProvider.propTypes = {
  children: PropTypes.node.isRequired
};
export default FlightResultsProvider;